import React, { Component } from "react";
import { Link } from "react-router-dom";

import { Form, Button, Modal, message, Input, Tag } from "antd";

import { connect } from "react-redux";
import { act_login, act_logout, act_sso } from "../../redux/actions";
import { formateDate } from "../../utils/dateUtil";
import { req_list_ccw_works_total } from "../../api";

import {
  ExclamationCircleOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import "./album-common.css";
const Item = Form.Item;

class AlbumHeader extends Component {
  state = {
    visible_menu: false,
    visible_logout: false,
    currentTime: formateDate(Date.now()),
    startTime: Date.now(),
    timeElapsed: 0,
    workingTime: 10,
    works: null,
  };

  ///////////////////////////////////////////////////////////////////

  getTime = () => {
    this.intervalId = setInterval(() => {
      const currentTime = formateDate(Date.now());
      this.setState({ currentTime });

      const runTime = new Date();
      const timeElapsed = Math.floor((runTime - this.state.startTime) / 1000);
      this.setState({ timeElapsed: timeElapsed });

      if (this.state.timeElapsed >= this.state.workingTime * 60) {
        clearInterval(this.intervalId);
        this.props.act_logout();
        this.refresh();
      }
    }, 1000);
  };

  logout = () => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: "確認要登出系統?",
      okText: "確認",
      cancelText: "取消",
      onOk: () => {
        this.props.act_logout();
        this.refresh();
      },
    });
  };

  onFinish = async (values) => {
    const { username, password } = values;
    let user_captcha = document.getElementById("user_captcha_input").value;
    if (validateCaptcha(user_captcha) === true) {
      this.props.act_login(username, password);
    } else {
      document.getElementById("user_captcha_input").value = "";
      message.info("驗證碼輸入錯誤");
      loadCaptchaEnginge(4, "purple", "white", "numbers");
    }
  };

  onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo)
  };

  validatePwd = (rule, value) => {
    // console.log(value)
    // if(/^[a-zA-Z0-9_]+$/.text(value)){ // 必須輸入是英文、數字或下滑線}
    return !value ? Promise.reject("必須輸入數據") : Promise.resolve(value);
  };

  refresh() {
    window.location.reload(false);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_all_total_items = async () => {
    const result = await req_list_ccw_works_total();
    if (result.total > 0) {
      const rows = result.data.map((item, index) => {
        return {
          name: item.ObjectType === "OTHER" ? "其他" : item.ObjectType,
          total: item.ObjectTotal.toLocaleString("en-US"),
        };
      });
      //console.log(rows)
      this.setState({ works: rows });
    } else {
      const works = null;
      this.setState({ works: works });
    }
  };

  ///////////////////////////////////////////////////////////////////

  componentDidMount() {
    this.getTime();
    this.api_all_total_items();
    loadCaptchaEnginge(4, "purple", "white", "numbers");
  }

  componentWillUnmount() {
    // 有定時器時要移除
    clearInterval(this.intervalId);
    this.props.act_logout();
  }

  ///////////////////////////////////////////////////////////////////

  render() {
    const user = this.props.user;
    const errorMeg = this.props.user.error_msg;
    const { works } = this.state;

    if (user && user.token) {
      const { userName } = this.props.user;

      const { currentTime } = this.state;
      return (
        <header>
          <div className="collapse bg-purple-1" id="navbarHeader">
            <div className="container">
              <div className="row">
                <div className="col-sm-8 col-md-7 py-4">
                  <h4 className="text-white">關於本平台</h4>
                  <p className="text-muted">
                    本校為厚實文創產業人才的基礎，在培育相關領域人才方面已呈多樣化，透過校務發展計畫，確立本校願景、教育目標與定位，以「文化創意」為發展核心，並以優質的「文創教學型」科技大學為定位，傾全校之力，營造特有之辦學特色，建構本校成為名副其實之文創學府。而本平台為收集本校師生文創作品，提供大家觀賞。
                  </p>
                  <span style={{ color: "white" }}>
                    {" "}
                    {works ? (
                      <>
                        累計至今
                        {works.map((item, index) => (
                          <span key={index}>
                            {" "}
                            <Tag color="geekblue">{item.name}</Tag>計有
                            {item.total}項 /{" "}
                          </span>
                        ))}
                      </>
                    ) : (
                      ""
                    )}{" "}
                  </span>
                </div>
                <div className="col-sm-4 offset-md-1 py-4">
                  <h4 className="text-white">用戶管理</h4>
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      <Button size="small" type="primary">
                        <i className="fas fa-user-alt"></i>
                        <span style={{ marginLeft: "3px" }}>
                          {" "}
                          {userName}，您好
                        </span>
                      </Button>
                    </li>
                    <li>
                      {" "}
                      <Button type="danger" size="small" onClick={this.logout}>
                        {" "}
                        登出{" "}
                        <i
                          style={{ marginLeft: "3px" }}
                          className="fas fa-sign-out-alt"
                        ></i>
                      </Button>{" "}
                      <Link to="/" target="_blank">
                        {" "}
                        <Button type="danger" size="small">
                          {" "}
                          管理{" "}
                          <i
                            style={{ marginLeft: "3px" }}
                            className="fas fa-photo-video"
                          ></i>
                        </Button>
                      </Link>
                    </li>
                    <li>
                      <div style={{ color: "white" }}>
                        <i className="far fa-clock"></i>{" "}
                        <span>{currentTime}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="navbar navbar-dark bg-purple-2 shadow-sm">
            <div className="container d-flex justify-content-between">
              <Link className="navbar-brand d-flex align-items-center" to="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  aria-hidden="true"
                  className="mr-2"
                  viewBox="0 0 24 24"
                  focusable="false"
                >
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
                <strong>文創作品平台</strong>
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarHeader"
                aria-controls="navbarHeader"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
        </header>
      );
    } else {
      return (
        <header>
          <div className="collapse bg-purple-1" id="navbarHeader">
            <div className="container">
              <div className="row">
                <div className="col-sm-8 col-md-7 py-4">
                  <h4 className="text-white">關於本平台</h4>
                  <p className="text-muted">
                    本校為厚實文創產業人才的基礎，在培育相關領域人才方面已呈多樣化，透過校務發展計畫，確立本校願景、教育目標與定位，以「文化創意」為發展核心，並以優質的「文創教學型」科技大學為定位，傾全校之力，營造特有之辦學特色，建構本校成為名副其實之文創學府。而本平台為收集本校師生文創作品，提供大家觀賞。
                  </p>
                  <span style={{ color: "white" }}>
                    {" "}
                    {works ? (
                      <>
                        累計至今
                        {works.map((item, index) => (
                          <span key={index}>
                            {" "}
                            <Tag color="geekblue">{item.name}</Tag>計有
                            {item.total}項 /{" "}
                          </span>
                        ))}
                      </>
                    ) : (
                      ""
                    )}{" "}
                  </span>
                </div>
                <div className="col-sm-4 offset-md-1 py-4">
                  <h4 className="text-white">用戶管理</h4>
                  {errorMeg ? message.error(errorMeg) : null}
                  <ul className="list-unstyled">
                    <li>
                      <Form
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        name="normal_login"
                        className="login-form"
                      >
                        <Item
                          name="username"
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: "必須輸入帳號",
                            },
                            { min: 4, message: "不符合帳號長度" },
                            {
                              pattern: /^[a-zA-Z0-9_]+$/,
                              message: "不符合帳號格式",
                            },
                          ]}
                        >
                          <Input
                            prefix={
                              <UserOutlined className="site-form-item-icon" />
                            }
                            placeholder={"學/職號"}
                          />
                        </Item>
                        <Item
                          name="password"
                          rules={[{ validator: this.validatePwd }]}
                        >
                          <Input
                            prefix={
                              <LockOutlined className="site-form-item-icon" />
                            }
                            type="password"
                            placeholder={"密碼"}
                          />
                        </Item>
                        <Item>
                          <div style={{ float: "left" }}>
                            <LoadCanvasTemplateNoReload />
                          </div>
                          <div style={{ float: "left" }}>
                            <span> &nbsp; </span>
                          </div>
                          <div style={{ float: "left" }}>
                            <input
                              placeholder="驗證碼"
                              id="user_captcha_input"
                              name="user_captcha_input"
                              className="form-control input-sm"
                              style={{ width: "100px", height: "31px" }}
                              type="text"
                              maxLength="4"
                              minLength="4"
                            ></input>
                          </div>
                          <div style={{ float: "left" }}>
                            <span> &nbsp;&nbsp;&nbsp; </span>
                          </div>
                          <div style={{ float: "left" }}>
                            <Button
                              htmlType="submit"
                              className="login-form-button"
                              type="primary"
                              danger
                            >
                              登入 <i className="fas fa-sign-in-alt"></i>
                            </Button>
                          </div>
                        </Item>
                      </Form>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="navbar navbar-dark bg-purple-2 shadow-sm">
            <div className="container d-flex justify-content-between">
              <Link className="navbar-brand d-flex align-items-center" to="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  aria-hidden="true"
                  className="mr-2"
                  viewBox="0 0 24 24"
                  focusable="false"
                >
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
                <strong>文創作品平台</strong>
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarHeader"
                aria-controls="navbarHeader"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
        </header>
      );
    }
  }
}

export default connect((state) => ({ user: state.user }), {
  act_login,
  act_logout,
  act_sso,
})(AlbumHeader);
